export class Customer {
    customerId: number;
    sex?: number;
    pelephone: string;
    fl: string;
    imagePath: string;
    comments: string;
    birthDay?: number;
    debt?: number;
    iconBirthday: string;
    iconDebt: string;
    idOfCategory: string;
    age?: number;
}

export class CustomCategory {
    custCategoryId?: number;
    custCategoryName?: string;
    isUsed?: boolean;
    orderId?: number;
}

export class CustomerLazy {
    page: number;
    size: number;
    sortField: string;
    sortOrder: number;
}

export class CustomerLazySearch {
    page: number;
    size: number;
    sortField: string;
    sortOrder: number;
    sex: number;
    classification: number;
    category: number;
    search: string;
}

export class CustomerLazyOut {
    totalCount: number;
    items: Customer[] = [];
}

export class Pelephone {
    phoneIn: string;
}




    export class IsCustomerPhone
    {
        isExist:boolean;
        fl:string;

    }